export default __webpack_public_path__ + "static/media/Cheng-Ho Battle Staff.39d770f6.jpg";